module.exports = __webpack_public_path__ + "static/miami1-0704bd87da6e6db159cec9f244435b2a.jpeg";